import NotificationItem from "./NotificationItem";
import {
  getCustomerNotification,
  getCustomerNotificationDetail,
} from "../../../../../actions/notification";
import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import SkeletonLoading from "./SkeletonLoading";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Notifications = () => {
  const customerNotifications = useSelector((state) => state.notification);
  const { loading, notifications } = customerNotifications;
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.toUpperCase();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCustomerNotification());
  }, [dispatch]);

  const handleDetailButton = (id) => {
    dispatch(getCustomerNotificationDetail(id));
  };

  return (
    <>
      {loading ? (
        <SkeletonLoading />
      ) : (
        <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] card-myPage tw:my-2">
          <div className="tw:flex-1 tw:p-4 tw:p-6">
            <div className="">
              {notifications?.uncheckedNotif?.length > 0 ||
                notifications?.checkedNotif?.length > 0 ? (
                <>
                  {notifications?.uncheckedNotif?.length > 0 && (
                    <>
                      <h5 className="tw:mb-6">{t("myPage.notification.subMenu.unchecked")}</h5>
                      {notifications?.uncheckedNotif?.map((val) => {
                        return (
                          <NotificationItem
                            title={lang == "EN" ? val.titleEN : val.titleJP}
                            description={
                              lang == "EN"
                                ? val.descriptionEN
                                : val.descriptionJP
                            }
                            id={val._id}
                            checkStatus={false}
                            handleDetailButton={handleDetailButton}
                          />
                        );
                      })}
                    </>
                  )}
                  {notifications?.checkedNotif?.length > 0 && (
                    <>
                      <h5 className="tw:mt-6 tw:mb-4">{t("myPage.notification.subMenu.checked")}</h5>
                      {notifications?.checkedNotif?.map((val) => {
                        return (
                          <NotificationItem
                            title={lang == "EN" ? val.titleEN : val.titleJP}
                            description={
                              lang == "EN"
                                ? val.descriptionEN
                                : val.descriptionJP
                            }
                            id={val._id}
                            checkStatus={true}
                            handleDetailButton={handleDetailButton}
                          />
                        );
                      })}
                    </>
                  )}
                </>
              ) : (
                <div className="tw:border tw:border-[#dee2e6] tw:flex tw:justify-center tw:items-center tw:py-12 tw:my-2 tw:rounded-[0.375rem]">
                  <p>{t("myPage.notification.noNotification")}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Notifications;
